module.exports = __webpack_public_path__ + "static/media/drink.87857c54.svg";